import { render, staticRenderFns } from "./ArchivoComunicados.vue?vue&type=template&id=549cc7d2&"
import script from "./ArchivoComunicados.vue?vue&type=script&lang=js&"
export * from "./ArchivoComunicados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports